"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonDetailsBanner = exports.PersonDetailsBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_details_banner_1 = require("./entity-details-banner");
var organisation_logo_1 = require("./organisation-logo");
var link_1 = require("../elements/link");
var cell_label_1 = require("../elements/cell-label");
var use_entities_1 = require("../../hooks/use-entities");
var cell_header_1 = require("../elements/cell-header");
exports.PersonDetailsBannerDefaultProps = {
  showOrg: false
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n\n  "], ["\n    padding: ", ";\n\n  "])), theme_1.theme.UNIT(3))
});
var OrgLogoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 180px;\n    padding: ", ";\n    padding-left: 0;\n  "], ["\n    max-width: 180px;\n    padding: ", ";\n    padding-left: 0;\n  "])), theme_1.theme.UNIT(3))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var OrgStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var OrgLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LogosStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var LogoLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex-shrink: 1;\n    margin-right: 16px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "], ["\n    flex-shrink: 1;\n    margin-right: 16px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "])))
});
var PositionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-weight: 300;\n    text-transform: uppercase;\n    margin-top: ", ";\n  "], ["\n    font-weight: 300;\n    text-transform: uppercase;\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(entity_details_banner_1.EntityDetailsBanner)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Org: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), OrgStyles),
  Logos: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LogosStyles),
  LogoLink: (0, styled_components_1.default)(link_1.Link)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LogoLinkStyles),
  OrgLogo: (0, styled_components_1.default)(organisation_logo_1.OrganisationLogo)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), OrgLogoStyles),
  OrgLink: (0, styled_components_1.default)(link_1.Link)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), OrgLinkStyles),
  Position: (0, styled_components_1.default)(cell_header_1.CellHeader)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles)
};
var PersonDetailsBanner = function (props) {
  var className = props.className,
    entity = props.entity,
    title = props.title,
    showMenu = props.showMenu,
    showOrg = props.showOrg,
    showSlug = props.showSlug;
  var entities = (0, use_entities_1.useEntities)();
  if (!entity) {
    return null;
  }
  var position = entity.position,
    organisation = entity.organisation;
  return react_1.default.createElement(My.Container, {
    title: title,
    showMenu: showMenu,
    badge: entity.role && entity.role.name,
    usePadding: false,
    showSlug: showSlug,
    entityTypeName: "Person",
    entity: entity,
    alwaysShowIcon: false,
    className: className,
    showDescription: false,
    controls: [!!position && organisation && react_1.default.createElement(My.Org, null, react_1.default.createElement(My.Label, null, position), react_1.default.createElement(My.Logos, null, react_1.default.createElement(My.LogoLink, {
      to: entities.Organisation.to(organisation.slug)
    }, react_1.default.createElement(My.OrgLogo, {
      maxHeight: "80px",
      entity: organisation
    }))))]
  });
};
exports.PersonDetailsBanner = PersonDetailsBanner;
exports.PersonDetailsBanner.defaultProps = exports.PersonDetailsBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;